<style>
 @import "../components/Styling/common.scss";
</style>

<template>
<div class="container">
    <center class="p-5">
        <img style="max-width: 90%" src="../assets/images/insdi.png">
    </center>
    <center>
        Either a firewall is blocking access to our servers or the link you followed is invalid.<br>
        If the problem persists, please contact us at support [at] insdi.com 
    </center><br>
    <center> <a href="https://www.insdi.com" rel="_blank">insdi.com</a></center>
</div>

</template>
<script>

export default {
    name: "BasePage",
    methods: {
    },
    data () {
        return {
            email: '',
            Error: ''
        }
    }
}
</script>
